import React, { useEffect, useState } from 'react';

export const useToggle = <
  Q,
  P extends (ev?: React.MouseEvent<Q>) => void = (
    ev?: React.MouseEvent<Q>
  ) => void
>(
  value?: boolean,
  condition?: boolean,
  listener?: P
) => {
  const [selected, setSelected] = useState<boolean | undefined>(value);

  useEffect(() => {
    setSelected(value);
  }, [value]);

  const toggle = (e?: React.MouseEvent<Q>) => {
    listener?.(e);

    if (condition || typeof condition === 'undefined') {
      setSelected(!selected);
    }
  };

  const close = () => {
    if (selected) setSelected(false);
  };

  return {
    selected,
    toggle,
    close
  };
};
